module.exports = __webpack_public_path__ + "img/ed21ca8.jpg";